import { Minus, Plus, ShoppingBag, Trash2, X } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useCommerce } from '../contexts/CommerceContext';
import { imageSource } from '../lib/assets';
import { formatPrice } from '../lib/format';
import { productFromCart } from '../services/products';

export function CartDrawer() {
  const { cart, products, cartOpen, setCartOpen, updateQuantity, removeFromCart, cartSubtotal, cartHasConsultation } = useCommerce();
  const lines = cart.map((item) => ({ item, product: productFromCart(item.productId, products) })).filter((line) => line.product);

  return (
    <>
      {cartOpen && <button className="page-scrim cart-scrim" aria-label="Fechar carrinho" onClick={() => setCartOpen(false)} />}
      <aside className={`cart-drawer ${cartOpen ? 'is-open' : ''}`} aria-label="Carrinho de compras" aria-hidden={!cartOpen}>
        <div className="drawer-header">
          <div><span className="eyebrow">Seu carrinho</span><h2>Escolhas da vez</h2></div>
          <button className="icon-button" aria-label="Fechar carrinho" onClick={() => setCartOpen(false)}><X /></button>
        </div>
        <div className="drawer-items">
          {!lines.length && (
            <div className="empty-state compact"><ShoppingBag size={30} /><p>Seu carrinho está esperando por uma peça especial.</p><Link onClick={() => setCartOpen(false)} to="/fitness">Ver fitness</Link></div>
          )}
          {lines.map(({ item, product }) => product && (
            <article className="cart-line" key={item.id}>
              <img src={imageSource(product.images[0])} alt="" />
              <div className="cart-line-info">
                <p className="product-category">{product.collection}</p>
                <h3>{product.name}</h3>
                <p className="muted">{item.color} · {item.size}</p>
                <p>{formatPrice(product.promotionalPrice ?? product.price)}</p>
                <div className="quantity-control" aria-label={`Quantidade de ${product.name}`}>
                  <button aria-label="Diminuir quantidade" onClick={() => updateQuantity(item.id, item.quantity - 1)}><Minus size={13} /></button>
                  <span>{item.quantity}</span>
                  <button aria-label="Aumentar quantidade" onClick={() => updateQuantity(item.id, item.quantity + 1)}><Plus size={13} /></button>
                </div>
              </div>
              <button className="remove-button" aria-label={`Remover ${product.name}`} onClick={() => removeFromCart(item.id)}><Trash2 size={16} /></button>
            </article>
          ))}
        </div>
        {!!lines.length && <div className="drawer-footer">
          {cartHasConsultation && <p className="consultation-note">Valores serão confirmados antes do pagamento.</p>}
          <div className="total-row"><span>Subtotal</span><strong>{cartHasConsultation ? 'A combinar' : formatPrice(cartSubtotal)}</strong></div>
          <p className="shipping-note">Frete calculado na etapa de entrega.</p>
          <Link className="button button-dark full-width" to="/checkout" onClick={() => setCartOpen(false)}>Finalizar compra</Link>
        </div>}
      </aside>
    </>
  );
}
